<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>邀请人：</label>
                <el-input v-model="search_Obj.f_email" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>被邀请人：</label>
                <el-input v-model="search_Obj.f_email_invited" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>添加时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="dateRangeSet"
                    style="width:320px">
                </el-date-picker>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="email" label="邀请人邮箱" sortable="custom"></el-table-column>
                <el-table-column prop="email_invited" label="邀请被人邮箱" sortable="custom"></el-table-column>
                <el-table-column prop="add_time" label="记录时间" sortable="custom"></el-table-column>
                <el-table-column prop="remark" label="备注" sortable="custom"></el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import listutil from "@/libs/listutil"
import { exportMemberInvite } from '@/api/member'

export default {
    name: 'memberInviteList',
    mixins: [listutil],
    components: {Btns, LabBtns},
    data() {
        return {
            m_name: '用户邀请',
            menu_id: 2600,
            list_url: "/api/admin/memberinvite/list",
            search_Obj: {
                f_email: '',
                f_email_invited: '',
                f_add_time_s_date: '',
                f_add_time_e_date: ''
            },
            del_Obj:{
                url:'/api/admin/memberinvite/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            dateRange: '',
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_add_time_s_date = val[0]
                this.search_Obj.f_add_time_e_date = val[1]
            }else{
                this.search_Obj.f_add_time_s_date = ''
                this.search_Obj.f_add_time_e_date = ''
            }
        },
        export(){
            exportMemberInvite(this.search_Obj.f_email, this.search_Obj.f_email_invited, this.search_Obj.f_add_time_s_date, this.search_Obj.f_add_time_e_date).then(res=>{
                if(res.code ==1){
                    setTimeout(() => {
                        window.open(res.data+"")
                    }, 500);
                }else if(res.code ==990){
                    this.$msg("无数据可导出")
                }else{
                    this.$msg(res.msg)
                }
            })
        }
    }
};
</script>